export enum VideoPlayState {
  Ready,
  Playing,
  Paused,
  Ended,
}
